import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CoursedurationListComponent } from './courseduration-list/courseduration-list.component';
import { CoursedurationCreateComponent } from './courseduration-create/courseduration-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: CoursedurationListComponent,
        data: {
          title: "Course Duration List",
          breadcrumb: "Course Duration List"
        }
      },
      {
        path: 'create',
        component: CoursedurationCreateComponent,
        data: {
          title: "Create Course Duration",
          breadcrumb: "Create Course Duration"
        }
      },
      {
        path: 'edit/:id',
        component: CoursedurationCreateComponent,
        data: {
          title: "Edit Course Duration",
          breadcrumb: "Edit Course Duration"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class CoursedurationRoutingModule { }
